const T = {

  // ── ARABIC ──────────────────────────────────────────────────
  ar: {
    appName: "مُحوِّل المستندات الذكي",
    appTagline: "الأداة الأولى لتحويل وترجمة المستندات العلمية بالعربية والفارسية والإنجليزية",
    langToggle: { ar: "العربية", fa: "فارسی", en: "English" },

    nav: {
      home: "الرئيسية", app: "التطبيق", pricing: "الأسعار",
      learning: "تعلّم منهجية البحث",
      login: "تسجيل الدخول", register: "إنشاء حساب",
      dashboard: "لوحة التحكم", logout: "تسجيل الخروج",
    },

    landing: {
      hero: {
        title: "حوّل مستنداتك العلمية بدقة لا مثيل لها",
        subtitle: "الأداة الوحيدة التي تحمي معادلاتك الرياضية أثناء الترجمة — عربي، فارسي، إنجليزي",
        cta: "ابدأ مجاناً",
        ctaSub: "لا يلزم بطاقة ائتمان",
      },
      features: {
        title: "لماذا مُحوِّل المستندات الذكي؟",
        items: [
          { icon: "Shield", title: "حماية المعادلات", desc: "تقنية فريدة تحمي معادلاتك الرياضية من التلف أثناء الترجمة بأي لغة" },
          { icon: "Zap", title: "تحويل فوري", desc: "نتائج دقيقة في ثوانٍ باستخدام Pandoc وpix2tex" },
          { icon: "Languages", title: "ثلاث لغات", desc: "عربي ↔ فارسي ↔ إنجليزي — ست اتجاهات للترجمة" },
          { icon: "FileCheck", title: "15+ محوّل", desc: "LaTeX، Word، PDF، استخراج المعادلات والجداول والأشكال، وترجمة LaTeX" },
          { icon: "Globe", title: "RTL كامل", desc: "دعم كامل للكتابة من اليمين لليسار للعربية والفارسية" },
          { icon: "Lock", title: "خصوصية تامة", desc: "LibreTranslate يعمل محلياً — بياناتك لا تغادر جهازك" },
        ],
      },
      howItWorks: {
        title: "كيف يعمل؟",
        steps: [
          { n: "1", title: "ارفع ملفك", desc: "اختر نوع التحويل وارفع ملفك بالسحب والإفلات" },
          { n: "2", title: "المعالجة الذكية", desc: "المحرك يحمي المعادلات ويحوّل النص بدقة" },
          { n: "3", title: "تحميل النتيجة", desc: "احصل على ملفك المحوّل جاهزاً للاستخدام" },
        ],
      },
      stats: [
        { value: "Multiple", label: "محوّلات" },
        { value: "3", label: "لغات مدعومة" },
        { value: "100%", label: "حماية المعادلات" },
        { value: "⚡", label: "تحويل سريع" }, /* SUBSCRIPTIONS_DISABLED: was { value: "∞", label: "تحويلات للمحترفين" } */
      ],
      cta2: {
        title: "جاهز للبدء؟",
        subtitle: "انضم إلى الباحثين الذين يثقون بمُحوِّل المستندات الذكي",
        button: "ابدأ مجاناً الآن",
      },
    },

    pricing: {
      title: "اختر خطتك",
      subtitle: "ابدأ مجاناً — قم بالترقية عندما تحتاج المزيد",
      free: {
        name: "مجاني", price: "$0",
        features: ["5 تحويلات يومياً", "ملفات حتى 5MB", "محرك LibreTranslate", "العربية والفارسية والإنجليزية", "محوّلات متعددة"],
        cta: "ابدأ مجاناً", highlight: false,
      },
      pro: {
        name: "احترافي", price: "$9", period: "/شهر",
        features: ["تحويلات غير محدودة", "ملفات حتى 50MB", "جميع محركات الترجمة", "العربية والفارسية والإنجليزية", "سجل التحويلات", "أولوية المعالجة", "دعم مباشر"],
        cta: "ابدأ التجربة المجانية", highlight: true,
      },
      faq: [
        { q: "هل يمكنني الإلغاء في أي وقت؟", a: "نعم، يمكنك الإلغاء من لوحة التحكم في أي وقت." },
        { q: "هل بياناتي آمنة؟", a: "LibreTranslate يعمل محلياً. Google Translate يستخدم واجهة API آمنة." },
        { q: "ما هي أنواع الملفات المدعومة؟", a: ".tex، .docx، .pdf، .png، .jpg" },
        { q: "هل المعادلات الفارسية محمية أيضاً؟", a: "نعم، محرك الحماية يعمل لجميع اللغات الثلاث." },
      ],
    },

    auth: {
      login: {
        title: "تسجيل الدخول", email: "البريد الإلكتروني", password: "كلمة المرور",
        submit: "دخول", noAccount: "ليس لديك حساب؟", register: "إنشاء حساب", loading: "جارٍ تسجيل الدخول...",
      },
      register: {
        title: "إنشاء حساب جديد", name: "الاسم الكامل", email: "البريد الإلكتروني",
        password: "كلمة المرور (8 أحرف على الأقل)", langPref: "لغة الواجهة المفضلة",
        submit: "إنشاء الحساب", hasAccount: "لديك حساب؟", login: "تسجيل الدخول", loading: "جارٍ إنشاء الحساب...",
      },
    },

    dashboard: {
      title: "لوحة التحكم", welcome: "مرحباً", plan: "خطتك الحالية",
      usage: "الاستخدام اليوم", of: "من", unlimited: "غير محدود",
      history: "سجل التحويلات", noHistory: "لا توجد تحويلات بعد",
      upgrade: "ترقية إلى الخطة الاحترافية", upgraded: "تمت الترقية بنجاح! 🎉",
      langStats: "اتجاهات الترجمة المستخدمة",
      modes: {
        latex_to_word: "LaTeX → Word", word_to_latex: "Word → LaTeX",
        pdf_to_latex: "PDF → LaTeX", pdf_to_word: "PDF → Word", image_to_latex: "صورة → LaTeX",
        translate_document: "ترجمة مستند", translate_tex: "ترجمة LaTeX",
      },
    },

    app: {
      serverOnline: "الخادم متصل", serverOffline: "الخادم غير متصل",
      step1: "اختر نوع التحويل", step2: "ارفع الملف", step3: "النتيجة",
      convertNow: "تحويل الآن →", translating: "جارٍ الترجمة...", converting: "جارٍ التحويل...",
      dropHere: "اسحب الملف هنا أو انقر للاختيار", accepted: "الصيغ المقبولة",
      success: "تم التحويل بنجاح! 🎉", download: "تحميل الملف",
      copyCode: "نسخ الكود", copied: "تم النسخ ✓", clear: "مسح",
      guestNote: "تستخدم التطبيق كزائر — سجّل للحصول على حد أعلى",
      limitReached: "وصلت للحد اليومي — قم بالترقية",
      engineLabel: "محرك الترجمة",
      engineSimple: "LibreTranslate — مجاني ومحلي",
      engineGoogle: "Google — مجاني، يدعم جميع الاتجاهات",
      sourceLang: "من", targetLang: "إلى",
      detecting: "جارٍ الكشف...",
      langs: { ar: "العربية", fa: "فارسی", en: "الإنجليزية" },
      swap: "⇄ تبديل",
      mathProtected: "🛡️ المعادلات محمية تلقائياً",
      mathOnlyNotice: "⚠️ هذه الأداة تقرأ المعادلات الرياضية فقط — لا تدعم النص العربي أو الفارسي أو الإنجليزي",
      directions: {
        "ar-en": "العربية → الإنجليزية", "en-ar": "الإنجليزية → العربية",
        "fa-en": "الفارسية → الإنجليزية", "en-fa": "الإنجليزية → الفارسية",
        "ar-fa": "العربية → الفارسية", "fa-ar": "الفارسية → العربية",
      },
      dirPicker: {
        choose: "اختر اتجاه التحويل",
        l2w: "LaTeX ← Word",
        w2l: "Word ← LaTeX",
        l2wSub: "رفع .tex واستلام .docx",
        w2lSub: "رفع .docx واستلام .tex",
      },
      articlePicker: {
        choose:     "اختر اتجاه التحويل",
        l2w:        "LaTeX ← Word",
        w2l:        "Word ← LaTeX",
        l2wSub:     "رفع .tex واستلام .docx",
        w2lSub:     "رفع .docx واستلام .tex مع قالب الناشر",
        publisher:  "الناشر المستهدف",
        pubType:    "نوع المستند",
        journal:    "مجلة علمية",
        conference: "مؤتمر",
      },
      modes: {
        ltw:  { title: "LaTeX ↔ Word", sub: "تحويل ثنائي الاتجاه مخصص للرسائل والأطروحات الأكاديمية — .tex إلى .docx أو .docx إلى .tex مع حماية المعادلات ودعم العربية والفارسية والإنجليزية" },
        'ltw-article': { title: "LaTeX ↔ Word (مقالات)", sub: "تحويل ثنائي الاتجاه مخصص للمقالات العلمية — مؤتمرات ومجلات — مع قوالب IEEE · ACM · Springer · Elsevier بثلاث لغات: العربية والفارسية والإنجليزية" },
        wtl:  { title: "Word إلى LaTeX",  sub: "تحويل .docx إلى .tex مع ديباجة عربية/فارسية تلقائية" },
        'ptl-nougat': { title: "PDF إلى LaTeX", sub: "تحويل PDF إلى LaTeX مع كشف تلقائي للغة — يدعم العربية والفارسية والإنجليزية" },
        itl:  { title: "صورة إلى LaTeX",  sub: "تعرف على المعادلات الرياضية في الصور بالذكاء الاصطناعي" },
        trd:  { title: "ترجمة المستند",   sub: "Word أو PDF مع حماية التنسيق والمعادلات" },
        trtx: { title: "ترجمة LaTeX",     sub: "ترجمة .tex مع حماية المعادلات" },
        'ptw-text':    { title: "PDF ← نص (Word)",     sub: "استخراج النص فقط بترتيب القراءة — عربي، فارسي، إنجليزي" },
        'ptw-math':    { title: "PDF ← معادلات (Word)", sub: "استخراج المعادلات كصور بالترتيب — يدعم جميع اللغات" },
        'ptw-figures': { title: "PDF ← أشكال (Word)",  sub: "استخراج جميع الأشكال مع تسمياتها — عربي، فارسي، إنجليزي" },
        'ptw-tables':  { title: "PDF ← جداول (Word)",  sub: "استخراج جميع الجداول مع هيكلها — عربي، فارسي، إنجليزي" },
        'ptl-text':    { title: "PDF ← نص (LaTeX)",    sub: "استخراج النص كأقسام LaTeX — عربي (polyglossia)، فارسي (xepersian)، إنجليزي" },
        'ptl-math':    { title: "PDF ← معادلات (LaTeX)", sub: "LaTeX عالي الثقة + صور للثقة المنخفضة — ZIP يحتوي .tex والصور" },
        'ptl-figures': { title: "PDF ← أشكال (LaTeX)", sub: "أشكال كـ \\includegraphics — ZIP يحتوي .tex والصور" },
        'ptl-tables':  { title: "PDF ← جداول (LaTeX)", sub: "جداول booktabs LaTeX الاحترافية — يدعم جميع اللغات" },
        'ltrans-en': { title: "ترجمة إلى الإنجليزية", sub: "ترجمة ملف .tex مع الحفاظ على المعادلات — يكتشف اللغة تلقائياً" },
        'ltrans-ar': { title: "ترجمة إلى العربية",    sub: "ترجمة ملف .tex مع الحفاظ على المعادلات — ديباجة RTL تلقائية" },
        'ltrans-fa': { title: "ترجمة إلى الفارسية",   sub: "ترجمة ملف .tex مع الحفاظ على المعادلات — ديباجة RTL تلقائية" },
        'merge-word':  { title: "دمج ملفات Word", sub: "ادمج عدة ملفات .docx في ملف واحد بالترتيب الذي تختاره" },
        'split-pdf':   { title: "تقسيم PDF",      sub: "قسّم ملف PDF إلى أجزاء منفصلة — بالصفحة أو النطاق أو الأجزاء المتساوية" },
        'split-word':  { title: "تقسيم Word",     sub: "قسّم ملف .docx عند فواصل الصفحات أو العناوين — الناتج ZIP يحتوي ملفات .docx" },
        'split-pptx':  { title: "تقسيم PowerPoint", sub: "قسّم ملف .pptx إلى شرائح أو نطاقات أو أجزاء — الناتج ZIP يحتوي ملفات .pptx" },
        'compress':    { title: "ضغط الملفات", sub: "اضغط PDF أو الصور أو DOCX أو PPTX أو أي ملف — اختر مستوى الجودة ووفّر المساحة" },
        'humanize':     { title: "إنسنة النص الأكاديمي", sub: "أعد صياغة النصوص الأكاديمية المُولَّدة بالذكاء الاصطناعي لتبدو طبيعية — مع الحفاظ على المعادلات والاستشهادات والمعنى الأصلي" },
        'pdf-rtl-word': { title: "PDF إلى Word (RTL/LTR)", sub: "تحويل ملفات PDF الأكاديمية إلى Word وLaTeX — يكتشف اتجاه النص تلقائياً، كشف المعادلات بالخط، دعم العربية والفارسية والإنجليزية" },
      },
    },

    footer: {
      tagline: "مُحوِّل المستندات الذكي — عربي • فارسي • إنجليزي",
      rights: "جميع الحقوق محفوظة",
    },

    errors: {
      noFile: "يرجى اختيار ملف أولاً", fileTooLarge: "حجم الملف كبير جداً",
      conversionFailed: "فشل التحويل", translationFailed: "فشل الترجمة",
      invalidDirection: "اتجاه الترجمة غير مدعوم",
      loginRequired: "يجب تسجيل الدخول", serverError: "خطأ في الخادم",
    },

    learning: {
      title: "مركز التعلم", subtitle: "دليل الباحث — من الفكرة إلى النشر",
      tabChapters: "الفصول", tabGlossary: "القاموس", tabGap: "أداة الفجوة البحثية",
      progress: "تقدّمك", loginPrompt: "سجّل دخولك لحفظ تقدمك",
      part: "الجزء", chapter: "الفصل", exercises: "التمارين",
      example: "مثال تطبيقي", taxonomyHeading: "تصنيف أنواع الفجوات البحثية",
      searchPlaceholder: "ابحث بالعربي أو الإنجليزي…",
      gapInstruction: "اختر نوع الفجوة، أدخل الموضوع والجانب الناقص، ويطلع لك نص جاهز.",
      topicLabel: "الموضوع {topic}", gapLabel: "الجانب الناقص {gap}",
      topicPlaceholder: "مثال: كشف التزوير بالتواقيع الرقمية",
      gapPlaceholder: "مثال: تأثير الضغط على دقة التعرف",
      outputAr: "العربي", outputEn: "English", copy: "نسخ",
      copied: "تم النسخ!", noResults: "لا توجد نتائج",
      enterInputs: "أدخل الموضوع والجانب الناقص لتوليد النص فوراً",
      heroDesc: "دليل شامل وتفاعلي لطلبة الدراسات العليا، من الماجستير إلى الدكتوراه، يغطي مهارات البحث العلمي، مراجعة الأدبيات، واستخراج الفجوات البحثية خطوة بخطوة، بأسلوب مبسط وأمثلة عملية.",
      howToUseTitle: "كيف تستخدم هذا الدليل؟",
      howToUse: "كل وحدة فيها شرح مبسط بالعربي (كأنك تتعلم الموضوع لأول مرة)، مصطلحات أساسية بالإنكليزي والعربي، مثال تطبيقي، وقائمة مهام تقدر تأشر عليها وتتحفظ تلقائياً. ابدأ من الوحدة 01 إذا أنت بأول الطريق، أو روح مباشرة للوحدة اللي تحتاجها.",
      tocTitle: "فهرس الوحدات",
      badgeUnits: "وحدة تدريبية",
      badgeInteractive: "تفاعلي وقابل للتطبيق",
    },
  },

  // ── PERSIAN / FARSI ─────────────────────────────────────────
  fa: {
    appName: "مبدل هوشمند اسناد",
    appTagline: "ابزار تبدیل و ترجمه دقیق اسناد علمی به عربی، فارسی و انگلیسی",
    langToggle: { ar: "العربية", fa: "فارسی", en: "English" },

    nav: {
      home: "خانه", app: "برنامه", pricing: "قیمت‌گذاری",
      learning: "یادگیری روش‌شناسی تحقیق",
      login: "ورود", register: "ثبت‌نام",
      dashboard: "داشبورد", logout: "خروج",
    },

    landing: {
      hero: {
        title: "اسناد علمی خود را با دقت بی‌نظیر تبدیل کنید",
        subtitle: "تنها ابزاری که معادلات ریاضی شما را در هنگام ترجمه محافظت می‌کند — فارسی، عربی، انگلیسی",
        cta: "شروع رایگان",
        ctaSub: "نیازی به کارت اعتباری نیست",
      },
      features: {
        title: "چرا مبدل هوشمند اسناد؟",
        items: [
          { icon: "Shield", title: "محافظت از معادلات", desc: "فناوری منحصربه‌فرد معادلات ریاضی را از آسیب هنگام ترجمه محافظت می‌کند" },
          { icon: "Zap", title: "تبدیل فوری", desc: "نتایج دقیق در چند ثانیه با استفاده از Pandoc و pix2tex" },
          { icon: "Languages", title: "سه زبان", desc: "فارسی ↔ عربی ↔ انگلیسی — شش جهت ترجمه" },
          { icon: "FileCheck", title: "۱۵+ مبدّل", desc: "LaTeX، Word، PDF، استخراج معادلات، جداول و تصاویر، ترجمه LaTeX" },
          { icon: "Globe", title: "RTL کامل", desc: "پشتیبانی کامل از راست به چپ برای فارسی و عربی" },
          { icon: "Lock", title: "حریم خصوصی کامل", desc: "LibreTranslate به صورت محلی اجرا می‌شود — داده‌های شما دستگاه را ترک نمی‌کند" },
        ],
      },
      howItWorks: {
        title: "چگونه کار می‌کند؟",
        steps: [
          { n: "1", title: "فایل خود را آپلود کنید", desc: "نوع تبدیل را انتخاب کنید و فایل را با کشیدن و رها کردن آپلود کنید" },
          { n: "2", title: "پردازش هوشمند", desc: "موتور معادلات را محافظت کرده و متن را با دقت تبدیل می‌کند" },
          { n: "3", title: "دانلود نتیجه", desc: "فایل تبدیل‌شده خود را آماده استفاده دریافت کنید" },
        ],
      },
      stats: [
        { value: "Multiple", label: "مبدّل" },
        { value: "3", label: "زبان پشتیبانی‌شده" },
        { value: "100%", label: "محافظت از معادلات" },
        { value: "⚡", label: "تبدیل سریع" }, /* SUBSCRIPTIONS_DISABLED: was { value: "∞", label: "تبدیل برای Pro" } */
      ],
      cta2: {
        title: "آماده شروع هستید؟",
        subtitle: "به پژوهشگرانی بپیوندید که به مبدل هوشمند اسناد اعتماد می‌کنند",
        button: "همین حالا رایگان شروع کنید",
      },
    },

    pricing: {
      title: "طرح خود را انتخاب کنید",
      subtitle: "رایگان شروع کنید — وقتی نیاز دارید ارتقا دهید",
      free: {
        name: "رایگان", price: "$0",
        features: ["۵ تبدیل در روز", "فایل‌ها تا ۵ مگابایت", "موتور LibreTranslate", "فارسی، عربی و انگلیسی", "مبدّل‌های متعدد"],
        cta: "رایگان شروع کنید", highlight: false,
      },
      pro: {
        name: "حرفه‌ای", price: "$9", period: "/ماه",
        features: ["تبدیل نامحدود", "فایل‌ها تا ۵۰ مگابایت", "همه موتورهای ترجمه", "فارسی، عربی و انگلیسی", "تاریخچه تبدیل‌ها", "پردازش اولویت‌دار", "پشتیبانی مستقیم"],
        cta: "آزمایش رایگان را شروع کنید", highlight: true,
      },
      faq: [
        { q: "آیا می‌توانم هر زمان لغو کنم؟", a: "بله، می‌توانید از داشبورد در هر زمان لغو کنید." },
        { q: "آیا داده‌هایم امن است؟", a: "LibreTranslate به صورت محلی اجرا می‌شود. Google Translate از API امن استفاده می‌کند." },
        { q: "چه فرمت‌های فایلی پشتیبانی می‌شوند؟", a: "‎.tex، .docx، .pdf، .png، .jpg" },
        { q: "آیا معادلات فارسی هم محافظت می‌شوند؟", a: "بله، موتور محافظت برای هر سه زبان کار می‌کند." },
      ],
    },

    auth: {
      login: {
        title: "ورود", email: "ایمیل", password: "رمز عبور",
        submit: "ورود", noAccount: "حساب ندارید؟", register: "ثبت‌نام", loading: "در حال ورود...",
      },
      register: {
        title: "ایجاد حساب جدید", name: "نام کامل", email: "ایمیل",
        password: "رمز عبور (حداقل ۸ کاراکتر)", langPref: "زبان رابط کاربری ترجیحی",
        submit: "ایجاد حساب", hasAccount: "حساب دارید؟", login: "ورود", loading: "در حال ایجاد حساب...",
      },
    },

    dashboard: {
      title: "داشبورد", welcome: "خوش آمدید", plan: "طرح فعلی شما",
      usage: "استفاده امروز", of: "از", unlimited: "نامحدود",
      history: "تاریخچه تبدیل‌ها", noHistory: "هنوز تبدیلی انجام نشده",
      upgrade: "ارتقا به طرح حرفه‌ای", upgraded: "با موفقیت ارتقا یافت! 🎉",
      langStats: "جهت‌های ترجمه استفاده‌شده",
      modes: {
        latex_to_word: "LaTeX → Word", word_to_latex: "Word → LaTeX",
        pdf_to_latex: "PDF → LaTeX", pdf_to_word: "PDF → Word", image_to_latex: "تصویر → LaTeX",
        translate_document: "ترجمه سند", translate_tex: "ترجمه LaTeX",
      },
    },

    app: {
      serverOnline: "سرور آنلاین است", serverOffline: "سرور آفلاین است",
      step1: "نوع تبدیل را انتخاب کنید", step2: "فایل را آپلود کنید", step3: "نتیجه",
      convertNow: "تبدیل کن →", translating: "در حال ترجمه...", converting: "در حال تبدیل...",
      dropHere: "فایل را اینجا بکشید یا کلیک کنید", accepted: "فرمت‌های پذیرفته‌شده",
      success: "با موفقیت تبدیل شد! 🎉", download: "دانلود فایل",
      copyCode: "کپی کد", copied: "کپی شد ✓", clear: "پاک کردن",
      guestNote: "به عنوان مهمان استفاده می‌کنید — برای حد بالاتر ثبت‌نام کنید",
      limitReached: "به حد روزانه رسیدید — برای تبدیل نامحدود ارتقا دهید",
      engineLabel: "موتور ترجمه",
      engineSimple: "LibreTranslate — رایگان و محلی",
      engineGoogle: "Google — رایگان، همه جهت‌ها",
      sourceLang: "از", targetLang: "به",
      detecting: "در حال تشخیص...",
      langs: { ar: "عربی", fa: "فارسی", en: "انگلیسی" },
      swap: "⇄ جابجایی",
      mathProtected: "🛡️ معادلات به طور خودکار محافظت می‌شوند",
      mathOnlyNotice: "⚠️ این ابزار فقط معادلات ریاضی را می‌خواند — متن فارسی، عربی یا انگلیسی نادیده گرفته می‌شود",
      directions: {
        "ar-en": "عربی → انگلیسی", "en-ar": "انگلیسی → عربی",
        "fa-en": "فارسی → انگلیسی", "en-fa": "انگلیسی → فارسی",
        "ar-fa": "عربی → فارسی", "fa-ar": "فارسی → عربی",
      },
      dirPicker: {
        choose: "جهت تبدیل را انتخاب کنید",
        l2w: "LaTeX ← Word",
        w2l: "Word ← LaTeX",
        l2wSub: "آپلود .tex و دریافت .docx",
        w2lSub: "آپلود .docx و دریافت .tex",
      },
      articlePicker: {
        choose:     "جهت تبدیل را انتخاب کنید",
        l2w:        "LaTeX ← Word",
        w2l:        "Word ← LaTeX",
        l2wSub:     "آپلود .tex و دریافت .docx",
        w2lSub:     "آپلود .docx و دریافت .tex با قالب ناشر",
        publisher:  "ناشر هدف",
        pubType:    "نوع سند",
        journal:    "مجله علمی",
        conference: "کنفرانس",
      },
      modes: {
        ltw:  { title: "LaTeX ↔ Word", sub: "تبدیل دوطرفه ویژه پایان‌نامه و رساله — .tex به .docx یا .docx به .tex با محافظت از معادلات و پشتیبانی از فارسی، عربی و انگلیسی" },
        'ltw-article': { title: "LaTeX ↔ Word (مقالات)", sub: "تبدیل دوطرفه ویژه مقالات علمی — کنفرانس و مجله — با قالب‌های IEEE · ACM · Springer · Elsevier به سه زبان: فارسی، عربی و انگلیسی" },
        wtl:  { title: "Word به LaTeX",    sub: "تبدیل .docx به .tex با پیش‌آمد فارسی/عربی خودکار" },
        'ptl-nougat': { title: "PDF به LaTeX", sub: "تبدیل PDF به LaTeX با تشخیص خودکار زبان — پشتیبانی از فارسی، عربی و انگلیسی" },
        itl:  { title: "تصویر به LaTeX",   sub: "تشخیص معادلات ریاضی در تصاویر با هوش مصنوعی" },
        trd:  { title: "ترجمه سند",        sub: "Word یا PDF با حفظ فرمت و معادلات" },
        trtx: { title: "ترجمه LaTeX",      sub: "ترجمه .tex با محافظت از معادلات" },
        'ptw-text':    { title: "PDF ← متن (Word)",       sub: "استخراج متن به ترتیب خواندن — فارسی، عربی، انگلیسی" },
        'ptw-math':    { title: "PDF ← معادلات (Word)",   sub: "استخراج معادلات به‌صورت تصویر — پشتیبانی از همه زبان‌ها" },
        'ptw-figures': { title: "PDF ← تصاویر (Word)",    sub: "استخراج همه تصاویر با عنوان — فارسی، عربی، انگلیسی" },
        'ptw-tables':  { title: "PDF ← جداول (Word)",     sub: "استخراج همه جداول با ساختار — فارسی، عربی، انگلیسی" },
        'ptl-text':    { title: "PDF ← متن (LaTeX)",      sub: "استخراج متن به‌عنوان بخش‌های LaTeX — فارسی (xepersian)، عربی، انگلیسی" },
        'ptl-math':    { title: "PDF ← معادلات (LaTeX)",  sub: "LaTeX با اطمینان بالا + تصویر برای اطمینان پایین — ZIP شامل .tex و تصاویر" },
        'ptl-figures': { title: "PDF ← تصاویر (LaTeX)",   sub: "تصاویر به‌صورت \\includegraphics — ZIP شامل .tex و تصاویر" },
        'ptl-tables':  { title: "PDF ← جداول (LaTeX)",    sub: "جداول حرفه‌ای booktabs LaTeX — پشتیبانی از همه زبان‌ها" },
        'ltrans-en': { title: "ترجمه به انگلیسی", sub: "ترجمه فایل .tex با حفظ معادلات — زبان به‌طور خودکار شناسایی می‌شود" },
        'ltrans-ar': { title: "ترجمه به عربی",    sub: "ترجمه فایل .tex با حفظ معادلات — پیش‌آمد RTL خودکار" },
        'ltrans-fa': { title: "ترجمه به فارسی",   sub: "ترجمه فایل .tex با حفظ معادلات — پیش‌آمد RTL خودکار" },
        'merge-word':  { title: "ادغام فایل‌های Word", sub: "چند فایل .docx را به ترتیب دلخواه در یک فایل ادغام کنید" },
        'split-pdf':   { title: "تقسیم PDF",           sub: "یک PDF را به بخش‌های جداگانه تقسیم کنید — صفحه، محدوده یا قطعات مساوی" },
        'split-word':  { title: "تقسیم Word",          sub: "فایل .docx را بر اساس شکست صفحه یا عنوان تقسیم کنید — خروجی ZIP حاوی .docx" },
        'split-pptx':  { title: "تقسیم PowerPoint",   sub: "فایل .pptx را به اسلاید، محدوده یا قطعات تقسیم کنید — خروجی ZIP حاوی .pptx" },
        'compress':    { title: "فشرده‌سازی فایل‌ها", sub: "PDF، تصاویر، DOCX، PPTX یا هر فایلی را فشرده کنید — سطح کیفیت را انتخاب کنید و فضا ذخیره کنید" },
        'humanize':     { title: "انسانی‌ساز متن علمی", sub: "متن آکادمیک تولیدشده توسط هوش مصنوعی را طبیعی بازنویسی کنید — با حفظ کامل معادلات، ارجاعات و معنا" },
        'pdf-rtl-word': { title: "PDF به Word (RTL/LTR)", sub: "تبدیل PDF‌های علمی به Word و LaTeX — تشخیص خودکار جهت متن، تشخیص معادلات بر اساس فونت، پشتیبانی از فارسی، عربی و انگلیسی" },
      },
    },

    footer: {
      tagline: "مبدل هوشمند اسناد — فارسی • عربی • انگلیسی",
      rights: "تمامی حقوق محفوظ است",
    },

    errors: {
      noFile: "لطفاً ابتدا یک فایل انتخاب کنید", fileTooLarge: "حجم فایل خیلی زیاد است",
      conversionFailed: "تبدیل ناموفق بود", translationFailed: "ترجمه ناموفق بود",
      invalidDirection: "جهت ترجمه پشتیبانی نمی‌شود",
      loginRequired: "ورود لازم است", serverError: "خطای سرور",
    },

    learning: {
      title: "مرکز یادگیری", subtitle: "راهنمای پژوهشگر — از ایده تا انتشار",
      tabChapters: "فصل‌ها", tabGlossary: "واژه‌نامه", tabGap: "ابزار شکاف پژوهشی",
      progress: "پیشرفت شما", loginPrompt: "برای ذخیره پیشرفت وارد شوید",
      part: "بخش", chapter: "فصل", exercises: "تمرین‌ها",
      example: "مثال کاربردی", taxonomyHeading: "طبقه‌بندی انواع شکاف پژوهشی",
      searchPlaceholder: "جستجو به عربی یا انگلیسی…",
      gapInstruction: "نوع شکاف را انتخاب کنید، موضوع و جنبه ناقص را وارد کنید.",
      topicLabel: "موضوع {topic}", gapLabel: "جنبه ناقص {gap}",
      topicPlaceholder: "مثال: تشخیص جعل در امضاهای دیجیتال",
      gapPlaceholder: "مثال: تأثیر فشار بر دقت تشخیص",
      outputAr: "عربی", outputEn: "English", copy: "کپی",
      copied: "کپی شد!", noResults: "نتیجه‌ای یافت نشد",
      enterInputs: "موضوع و جنبه ناقص را وارد کنید تا متن فوری تولید شود",
      heroDesc: "راهنمای جامع و تعاملی برای دانشجویان تحصیلات تکمیلی، از کارشناسی ارشد تا دکترا، که مهارت‌های پژوهش علمی، مرور ادبیات، و استخراج شکاف‌های پژوهشی را گام به گام پوشش می‌دهد.",
      howToUseTitle: "چگونه از این راهنما استفاده کنیم؟",
      howToUse: "هر واحد شامل توضیح ساده، اصطلاحات کلیدی، مثال کاربردی و فهرست تکالیف است که می‌توانید آن‌ها را علامت‌گذاری کنید. از واحد ۰۱ شروع کنید یا مستقیم به واحد مورد نیاز بروید.",
      tocTitle: "فهرست واحدها",
      badgeUnits: "واحد آموزشی",
      badgeInteractive: "تعاملی و کاربردی",
    },
  },

  // ── ENGLISH ─────────────────────────────────────────────────
  en: {
    appName: "Smart Document Converter",
    appTagline: "High-precision scientific document conversion for Arabic, Persian and English",
    langToggle: { ar: "العربية", fa: "فارسی", en: "English" },

    nav: {
      home: "Home", app: "App", learning: "Research Methodology Learning", pricing: "Pricing",
      login: "Login", register: "Sign Up",
      dashboard: "Dashboard", logout: "Logout",
    },

    landing: {
      hero: {
        title: "Convert Scientific Documents with Unmatched Precision",
        subtitle: "The only tool that protects math equations during translation — Arabic, Persian, English",
        cta: "Start Free",
        ctaSub: "No credit card required",
      },
      features: {
        title: "Why Smart Document Converter?",
        items: [
          { icon: "Shield", title: "Equation Protection", desc: "Unique technology protects all math equations from corruption during translation in any language" },
          { icon: "Zap", title: "Instant Conversion", desc: "Accurate results in seconds using Pandoc and pix2tex" },
          { icon: "Languages", title: "Three Languages", desc: "Arabic ↔ Persian ↔ English — six translation directions" },
          { icon: "FileCheck", title: "15+ Converters", desc: "LaTeX, Word, PDF, equation/table/figure extraction, and LaTeX translation" },
          { icon: "Globe", title: "Full RTL Support", desc: "Complete right-to-left support for Arabic and Persian" },
          { icon: "Lock", title: "Full Privacy", desc: "LibreTranslate runs locally — your data never leaves your machine" },
        ],
      },
      howItWorks: {
        title: "How It Works",
        steps: [
          { n: "1", title: "Upload Your File", desc: "Choose conversion type and upload via drag & drop" },
          { n: "2", title: "Smart Processing", desc: "Engine protects equations and converts text precisely" },
          { n: "3", title: "Download Result", desc: "Get your converted file ready to use" },
        ],
      },
      stats: [
        { value: "Multiple", label: "Converters" },
        { value: "3", label: "Supported Languages" },
        { value: "100%", label: "Equation Protection" },
        { value: "⚡", label: "Fast Conversions" }, /* SUBSCRIPTIONS_DISABLED: was { value: "∞", label: "Pro Conversions" } */
      ],
      cta2: {
        title: "Ready to Start?",
        subtitle: "Join researchers who trust Smart Document Converter",
        button: "Start Free Now",
      },
    },

    pricing: {
      title: "Choose Your Plan",
      subtitle: "Start free — upgrade when you need more",
      free: {
        name: "Free", price: "$0",
        features: ["5 conversions per day", "Files up to 5MB", "LibreTranslate engine", "Arabic, Persian & English", "Multiple converters"],
        cta: "Start Free", highlight: false,
      },
      pro: {
        name: "Pro", price: "$9", period: "/month",
        features: ["Unlimited conversions", "Files up to 50MB", "All translation engines", "Arabic, Persian & English", "Conversion history", "Priority processing", "Direct support"],
        cta: "Start Free Trial", highlight: true,
      },
      faq: [
        { q: "Can I cancel anytime?", a: "Yes, cancel from your dashboard at any time." },
        { q: "Is my data private?", a: "LibreTranslate runs locally. Google Translate uses a secure API." },
        { q: "What file formats are supported?", a: ".tex, .docx, .pdf, .png, .jpg" },
        { q: "Are Persian equations also protected?", a: "Yes, the protection engine works for all three languages." },
      ],
    },

    auth: {
      login: {
        title: "Login", email: "Email", password: "Password",
        submit: "Login", noAccount: "Don't have an account?", register: "Sign Up", loading: "Logging in...",
      },
      register: {
        title: "Create New Account", name: "Full Name", email: "Email",
        password: "Password (min 8 characters)", langPref: "Preferred Interface Language",
        submit: "Create Account", hasAccount: "Already have an account?", login: "Login", loading: "Creating account...",
      },
    },

    dashboard: {
      title: "Dashboard", welcome: "Welcome", plan: "Your Current Plan",
      usage: "Today's Usage", of: "of", unlimited: "Unlimited",
      history: "Conversion History", noHistory: "No conversions yet",
      upgrade: "Upgrade to Pro", upgraded: "Successfully upgraded! 🎉",
      langStats: "Translation directions used",
      modes: {
        latex_to_word: "LaTeX → Word", word_to_latex: "Word → LaTeX",
        pdf_to_latex: "PDF → LaTeX", pdf_to_word: "PDF → Word", image_to_latex: "Image → LaTeX",
        translate_document: "Translate Document", translate_tex: "Translate LaTeX",
      },
    },

    app: {
      serverOnline: "Server Online", serverOffline: "Server Offline",
      step1: "Choose Conversion Type", step2: "Upload File", step3: "Result",
      convertNow: "Convert Now →", translating: "Translating...", converting: "Converting...",
      dropHere: "Drag file here or click to select", accepted: "Accepted formats",
      success: "Converted successfully! 🎉", download: "Download File",
      copyCode: "Copy Code", copied: "Copied ✓", clear: "Clear",
      guestNote: "Using as guest — register for higher limits",
      limitReached: "Daily limit reached — upgrade for unlimited conversions",
      engineLabel: "Translation Engine",
      engineSimple: "LibreTranslate — free & local",
      engineGoogle: "Google — free, all language pairs",
      sourceLang: "From", targetLang: "To",
      detecting: "detecting…",
      langs: { ar: "Arabic", fa: "Persian", en: "English" },
      swap: "⇄ Swap",
      mathProtected: "🛡️ Equations protected automatically",
      mathOnlyNotice: "⚠️ This tool reads math equations only — Arabic, English, and Persian text will be ignored",
      directions: {
        "ar-en": "Arabic → English", "en-ar": "English → Arabic",
        "fa-en": "Persian → English", "en-fa": "English → Persian",
        "ar-fa": "Arabic → Persian", "fa-ar": "Persian → Arabic",
      },
      dirPicker: {
        choose: "Choose conversion direction",
        l2w: "LaTeX → Word",
        w2l: "Word → LaTeX",
        l2wSub: "Upload .tex, get .docx",
        w2lSub: "Upload .docx, get .tex",
      },
      articlePicker: {
        choose:     "Choose conversion direction",
        l2w:        "LaTeX → Word",
        w2l:        "Word → LaTeX",
        l2wSub:     "Upload .tex, get .docx",
        w2lSub:     "Upload .docx, get .tex with publisher template",
        publisher:  "Target publisher",
        pubType:    "Document type",
        journal:    "Journal",
        conference: "Conference",
      },
      modes: {
        ltw:  { title: "LaTeX ↔ Word", sub: "Bidirectional conversion built for theses & dissertations — .tex↔.docx with math protection, per-run RTL/LTR, in Arabic, Persian & English" },
        'ltw-article': { title: "LaTeX ↔ Word (Articles)", sub: "Bidirectional conversion for academic articles — conferences & journals — with IEEE · ACM · Springer · Elsevier templates in Arabic, Persian & English" },
        wtl:  { title: "Word to LaTeX",      sub: "Convert .docx to .tex with auto Arabic/Persian preamble" },
        'ptl-nougat': { title: "PDF → LaTeX", sub: "Convert PDF to LaTeX with automatic language detection — supports EN, AR & FA" },
        itl:  { title: "Image to LaTeX",     sub: "AI-powered math formula recognition via pix2tex" },
        trd:  { title: "Translate Document", sub: "Word or PDF, formatting & equations preserved" },
        trtx: { title: "Translate LaTeX",    sub: "Translate .tex with math protection" },
        'ptw-text':    { title: "PDF → Text (Word)",      sub: "Extract text in reading order — Arabic, Persian, English" },
        'ptw-math':    { title: "PDF → Math (Word)",      sub: "Extract equations as images in order — any language" },
        'ptw-figures': { title: "PDF → Figures (Word)",   sub: "Extract all figures with captions — Arabic, Persian, English" },
        'ptw-tables':  { title: "PDF → Tables (Word)",    sub: "Extract all tables with structure — Arabic, Persian, English" },
        'ptl-text':    { title: "PDF → Text (LaTeX)",     sub: "Extract text as LaTeX sections — Arabic (polyglossia), Persian (xepersian), English" },
        'ptl-math':    { title: "PDF → Math (LaTeX)",     sub: "High-confidence LaTeX + image fallback — ZIP with .tex and images" },
        'ptl-figures': { title: "PDF → Figures (LaTeX)",  sub: "Figures as \\includegraphics blocks — ZIP with .tex and images" },
        'ptl-tables':  { title: "PDF → Tables (LaTeX)",   sub: "Professional booktabs LaTeX tables — any language" },
        'ltrans-en': { title: "Translate → English", sub: "Translate .tex to English — math frozen, auto-detects source language" },
        'ltrans-ar': { title: "Translate → Arabic",  sub: "Translate .tex to Arabic — math frozen, RTL preamble, auto-detects source" },
        'ltrans-fa': { title: "Translate → Farsi",   sub: "Translate .tex to Farsi — math frozen, RTL preamble, auto-detects source" },
        'merge-word':  { title: "Merge Word Files",        sub: "Combine multiple .docx files into one in the order you choose" },
        'split-pdf':   { title: "Split PDF",               sub: "Split a PDF into parts — individual pages, custom ranges (1-3,5,7-10), or equal chunks" },
        'split-word':  { title: "Split Word",              sub: "Split a .docx at page breaks or Heading 1 boundaries — output is a ZIP of .docx files" },
        'split-pptx':  { title: "Split PowerPoint",        sub: "Split a .pptx into slides, ranges, or equal chunks — output is a ZIP of .pptx files" },
        'compress':    { title: "Compress Files",           sub: "Compress PDF, images, DOCX, PPTX, or any file — choose quality level and reduce file size" },
        'humanize':     { title: "Academic Humanizer",         sub: "Rewrite AI-generated academic text to sound natural — math equations, citations, and meaning preserved exactly" },
        'pdf-rtl-word': { title: "PDF → Word (RTL/LTR)",      sub: "Convert academic PDFs to Word and LaTeX — auto RTL/LTR detection, font-based equation detection, Arabic, Persian & English" },
      },
    },

    footer: {
      tagline: "Smart Document Converter — Arabic • Persian • English",
      rights: "All rights reserved",
    },

    errors: {
      noFile: "Please select a file first", fileTooLarge: "File size too large",
      conversionFailed: "Conversion failed", translationFailed: "Translation failed",
      invalidDirection: "Translation direction not supported",
      loginRequired: "Login required", serverError: "Server error",
    },

    learning: {
      title: "Learning Center", subtitle: "Researcher's Guide — From Idea to Publication",
      tabChapters: "Chapters", tabGlossary: "Glossary", tabGap: "Gap Tool",
      progress: "Your Progress", loginPrompt: "Sign in to save your progress",
      part: "Part", chapter: "Chapter", exercises: "Exercises",
      example: "Applied Example", taxonomyHeading: "Research Gap Taxonomy",
      searchPlaceholder: "Search in Arabic or English…",
      gapInstruction: "Select a gap type, enter your topic and the missing aspect to generate ready-to-insert text.",
      topicLabel: "Topic {topic}", gapLabel: "Missing Aspect {gap}",
      topicPlaceholder: "e.g. digital signature forgery detection",
      gapPlaceholder: "e.g. effect of writing pressure on recognition accuracy",
      outputAr: "Arabic", outputEn: "English", copy: "Copy",
      copied: "Copied!", noResults: "No results found",
      enterInputs: "Enter topic and missing aspect to generate text instantly",
      heroDesc: "A comprehensive interactive guide for graduate students — from master's to doctoral level — covering research skills, literature review, and research gap identification step by step, with clear examples.",
      howToUseTitle: "How to use this guide?",
      howToUse: "Each unit has a plain-language explanation, key bilingual terms, an applied example, and a task checklist you can tick off. Start from unit 01 or jump straight to the unit you need.",
      tocTitle: "Table of Contents",
      badgeUnits: "training units",
      badgeInteractive: "Interactive & Practical",
    },
  },
};

export default T;
